import { render, staticRenderFns } from "./ComplaintManagement.vue?vue&type=template&id=47444060"
import script from "./ComplaintManagement.vue?vue&type=script&lang=js"
export * from "./ComplaintManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports